export default __webpack_public_path__ + "static/media/annex1.d740bef3.png";